export const MOVIDESK_CLIENT_VARIABLE = process.env.VUE_APP_MOVIDESK_CLIENT_VARIABLE;
export const MOVIDESK_CHAT_URL = process.env.VUE_APP_MOVIDESK_CHAT_URL;
